import { showError } from '@automator/builder/utils';

// Import utils
import { isEmpty } from '@automator/shared/utils/is-empty';

class RecipeNotices {
	constructor() {
		// Check if error mode is enabled
		if ( UncannyAutomator.recipe.errorMode ) {
			// Create error
			this.createError();
		}
	}

	createError() {
		// Check if we have to create the notice
		if ( ! isEmpty( UncannyAutomator.recipe.message.error ) ) {
			showError( UncannyAutomator.recipe.message.error );
		}
	}
}

export default RecipeNotices;
